import { defineMessages } from "react-intl";
export default defineMessages({
  welcome: {
    "id": "auth.welcome",
    "defaultMessage": "Welcome to SmartMixin"
  },
  catchPhrase: {
    "id": "auth.catchPhrase",
    "defaultMessage": "The Weather Intelligence Platform"
  },
  register: {
    "id": "auth.register",
    "defaultMessage": "Create account"
  },
  registerSuccess: {
    "id": "auth.registerSuccess",
    "defaultMessage": "You've successfully registered! We've just sent you a verification link at {emailAddress} with further instructions."
  },
  login: {
    "id": "auth.login",
    "defaultMessage": "Login"
  },
  loginToSmartMixinDescription: {
    "id": "auth.loginToSmartMixinDescription",
    "defaultMessage": "Enter your SmartMixin credentials to access your account."
  },
  socialAccount: {
    "id": "auth.socialAccount",
    "defaultMessage": "or use your account"
  },
  firstName: {
    "id": "auth.firstName",
    "defaultMessage": "First name"
  },
  lastName: {
    "id": "auth.lastName",
    "defaultMessage": "Last name"
  },
  email: {
    "id": "auth.email",
    "defaultMessage": "Email address"
  },
  password: {
    "id": "auth.password",
    "defaultMessage": "Password"
  },
  passwordAgain: {
    "id": "auth.passwordAgain",
    "defaultMessage": "Password again"
  },
  forgotPassword: {
    "id": "auth.forgotPassword",
    "defaultMessage": "Forgot your password?"
  },
  restorePasswordSuccess: {
    "id": "auth.restorePasswordSuccess",
    "defaultMessage": "We've just sent you a password reset link at {emailAddress} with further instructions."
  },
  welcomeBack: {
    "id": "auth.welcomeBack",
    "defaultMessage": "Welcome back!"
  },
  restorePassword: {
    "id": "auth.restorePassword",
    "defaultMessage": "Restore Password"
  },
  sendReset: {
    "id": "auth.sendReset",
    "defaultMessage": "Send reset instructions"
  },
  logout: {
    "id": "auth.logout",
    "defaultMessage": "Logout"
  },
  logoutConfirmation: {
    "id": "auth.logoutConfirmation",
    "defaultMessage": "Are you sure you want to logout?"
  },
  emailRequiredLoginFacebook: {
    "id": "auth.emailRequiredLoginFacebook",
    "defaultMessage": "Email permission is required."
  },
  passwordReset: {
    "id": "auth.passwordReset",
    "defaultMessage": "Password reset"
  },
  passwordResetSuccess: {
    "id": "auth.passwordResetSuccess",
    "defaultMessage": "Your password has been successfully updated."
  },
  emailVerification: {
    "id": "auth.emailVerification",
    "defaultMessage": "Email verification"
  },
  emailVerificationSuccess: {
    "id": "auth.emailVerificationSuccess",
    "defaultMessage": "Your email has been successfully verified."
  },
  emailVerificationFailure: {
    "id": "auth.emailVerificationFailure",
    "defaultMessage": "A problem occurred with your email verification."
  }
});